import React, { memo, useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  getAppealsStageCurrent,
} from '../../selectors'
import {
  selectStagePlanError,
  selectStagePlanIsLoading,
  selectStagePlanData,
  StagePlanSync as StagePlan
} from "../../../../../components/v2/stage-plan";
import {getStagePlanData} from "../../../../../store/stagePlan/action-creators";
import {setStagePlanClear} from "../../../../../store/stagePlan/actions";
import { useAppDispatch } from '../../../../../hooks/useAppDispatch/useAppDispatch'



interface AppealsStagePlanProps {
  className?: string
  id: string | number
  hideHeader?: boolean
}

export const AppealStagePlan: React.FC<AppealsStagePlanProps> = memo((props: AppealsStagePlanProps) => {
  const {className, id, hideHeader} = props
  const dispatch = useAppDispatch()
  const stagePlanIsLoading = useSelector(selectStagePlanIsLoading)
  const stagePlanError = useSelector(selectStagePlanError)
  const stagePlanFiles = useSelector(selectStagePlanData)
  const stage = useSelector(getAppealsStageCurrent)

  useEffect(() => {
    let mounted = true
    if (stage !== undefined && id !== 'new') {
      if (mounted) {
        dispatch(getStagePlanData('appeal',id))
      }
    }
    return () => {
      mounted = false
      dispatch(setStagePlanClear());
    }
  }, [stage, id, dispatch])

  return (
    <StagePlan
      isLoading={stagePlanIsLoading}
      items={stagePlanFiles}
      error={stagePlanError}
      className={className}
      title={'Прогноз исполнения'}
      emptyMessage={'Прогноз исполнения пуст'}
      typeItem={'appeal'}
      hideHeader={hideHeader}
    />
  )
})
